import "./Details.css";

import React, {memo, useEffect, useState} from "react";

import {DocPhraseTestResult, DocType} from "../types";
import {validationRulesService} from "../services/validationRulesService";
import {DataLoadingStatus} from "shared/types/common";
import PhraseTestResultComponent from "./PhraseTestResultComponent";


const TestCustomPhraseComponent = ({cat_id, selectedDocType}: { cat_id: number, selectedDocType: DocType }) => {
    const [phrase, setPhrase] = useState<string>('');
    const [networkError, setNetworkError] = useState<number>(0);
    const [dataLoadingStatus, setDataLoadingStatus] = useState<DataLoadingStatus>(DataLoadingStatus.NotLoaded);
    const [testResult, setTestResult] = useState<DocPhraseTestResult[]|undefined>(undefined);
    
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setDataLoadingStatus(DataLoadingStatus.Loading);
        validationRulesService.testCategoryPhrase(cat_id, phrase.trim()).then(response => {
            if (response.errorCode) {
                setNetworkError(response.errorCode);
                setDataLoadingStatus(DataLoadingStatus.Error);
            } else if (!response.success) {
                setDataLoadingStatus(DataLoadingStatus.NotLoaded);
                alert(response.message);
            } else {
                alert(response.message);
                setTestResult(response.result);
                setDataLoadingStatus(DataLoadingStatus.Loaded);
            }
        });
    };

    useEffect(() => {
        setPhrase("");
        setNetworkError(0);
        setDataLoadingStatus(DataLoadingStatus.NotLoaded);
        setTestResult(undefined);
    }, [cat_id]);
    
    return (
        <>
            <h3>Test custom phrase:</h3>
            {testResult !== undefined? <PhraseTestResultComponent phrase={testResult.find(res => res.doc_type === selectedDocType)!.phrase}/> : <></>}
            <div className="form-container">
                <form className='form' onSubmit={handleSubmit}>
                    <label htmlFor="phrase">Enter your phrase:</label>
                    <input type="text"
                           id="phrase"
                           value={phrase}
                           disabled={dataLoadingStatus === DataLoadingStatus.Loading}
                           onChange={(event) => {
                               setPhrase(event.target.value);
                               setDataLoadingStatus(DataLoadingStatus.NotLoaded);
                           }}
                    />
                    <p className="info-text-mini">
                        {dataLoadingStatus === DataLoadingStatus.Loading ?
                            "Waiting for response..." : ""}
                    </p>
                    <p className="error-text-mini">
                        {dataLoadingStatus === DataLoadingStatus.Error ?
                                `Error: ${networkError}` : 
                            phrase.length > 0 && phrase.length <= 5? "Phrase is to short" : ""
                        }
                    </p>
                    <button className="button green-button" type="submit" disabled={phrase.length <= 5 || dataLoadingStatus === DataLoadingStatus.Loading}>
                        Test Phrase
                    </button>
                </form>
            </div>
        </>
    );
};

export default memo(TestCustomPhraseComponent);
